/* Action Types */
export const LOAD_FEATURED_CATALOGS_FAIL = 'LOAD_FEATURED_CATALOGS_FAIL';
export const LOAD_FEATURED_CATALOGS_REQUEST = 'LOAD_FEATURED_CATALOGS_REQUEST';
export const LOAD_FEATURED_CATALOGS_SUCCESS = 'LOAD_FEATURED_CATALOGS_SUCCESS';
